import '../export/exportBoundary.container.autoload';
import '../export/exportBoundaryTerritory.container.autoload';
import { useCallback } from 'react';
import { useModal } from '../../../../../modal/useModal.hook';

export const useBoundaryExportData = () => {
  const { openModal: openExportBoundaryDataModal } = useModal('ExportBoundaryData');
  const { openModal: openExportTerritoryDataModal } = useModal('ExportTerritoryData');

  const exportBoundaryData = useCallback((boundaryTerritoryGroupId: number, boundaryId: number) => {
    openExportBoundaryDataModal({
      boundaryTerritoryGroupId,
      boundaryId,
    });
  }, [openExportBoundaryDataModal]);

  const exportBoundaryTerritoryData = useCallback((boundaryTerritoryGroupId: number, boundaryTerritoryId: string) => {
    openExportTerritoryDataModal({
      boundaryTerritoryGroupId,
      boundaryTerritoryId,
    });
  }, [openExportTerritoryDataModal]);

  return {
    exportBoundaryData,
    exportBoundaryTerritoryData,
  };
};
